export default () => {
    /* global URL */
    const url = new URL(window.location);
    return url.hostname;
}